import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Typography from '../Typography';
import Tooltip from '../Tooltip';

const PolicyRow = ({
  value,
  className,
  label,
  style,
  valueStyle,
  onClick,
  subtitle = '',
  withTab = false,
  labelStyle,
  valueClassName,
  ariaLabel = 'Policy Contact Email Tooltip',
  tooltip = null,
  id,
}) =>
  !!value && (
    <dl className={className} style={style}>
      <dt>
        <Typography
          style={{ display: 'inline-flex', ...labelStyle }}
          type="caption1"
        >
          {label}
        </Typography>
        {tooltip && (
          <Tooltip
            ariaLabel={ariaLabel}
            text={tooltip}
            dataFor={`${label.toLowerCase().replace(' ', '-')}-tooltip`}
          />
        )}
      </dt>
      {subtitle !== '' && (
        <>
          <Typography
            type="caption1"
            component="span"
            style={valueStyle}
            onClick={onClick}
          >
            {subtitle}
          </Typography>
        </>
      )}
      <dd style={{ margin: 0 }}>
        <Typography
          id={id || label}
          type="caption2"
          component="span"
          style={valueStyle}
          className={clsx(valueClassName)}
          onClick={onClick}
          withTab={withTab}
        >
          {value}
        </Typography>
      </dd>
    </dl>
  );

PolicyRow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.any,
  ]),
  valueStyle: PropTypes.object,
  onClick: PropTypes.func,
  subtitle: PropTypes.string,
  withTab: PropTypes.bool,
  labelStyle: PropTypes.object,
  valueClassName: PropTypes.string,
  keepVertical: PropTypes.bool,
  vertical: PropTypes.bool,
  tooltip: PropTypes.string,
  id: PropTypes.string,
};

export default PolicyRow;
